/*
  Cart transfer between isaia.it (ROW) and isaia.us (US).
  Same file on both themes, configured by snippets/cart-transfer.liquid.

  Leaving: a click on a link to the other store (country selector, geo popup)
  reads /cart.js and sends the bag along in the URL. An empty bag leaves as before.
  /cart?ship_to=XX (the "click here" of the checkout) does the same towards the cart.
  On the published theme the way out goes through a URL redirect of this store
  (config.exitPath / exitCartPath, Navigation > URL redirects), so Shopify's exit
  confirmation does not stop the customer between the two stores (ISAIA, 21-10-2026).
  Arriving: /cart?cart_transfer=... finds each item by handle and SKU, adds what
  can be bought and remembers the rest, which the cart shows in red. Then the
  customer lands on the page they were browsing, if it exists here, with a short
  notice; from the cart or the checkout they land on the cart.
*/
(function () {
  var config = window.isaiaCartTransferConfig;
  if (!config) return;

  var NA_KEY = 'isaiaCartTransferNA';
  var DONE_KEY = 'isaiaCartTransferDone';
  var TOAST_KEY = 'isaiaCartTransferToast';
  var NA_TTL = 7 * 24 * 60 * 60 * 1000;
  /* Rows saved before this release are dropped, so nobody keeps red rows from older versions (ISAIA, 21-10-2026). */
  var NA_SINCE = Date.parse('2026-10-21T10:35:32Z');

  /* ---------- helpers ---------- */

  function encode(data) {
    var bytes = new TextEncoder().encode(JSON.stringify(data));
    var binary = '';
    bytes.forEach(function (b) { binary += String.fromCharCode(b); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function decode(text) {
    var binary = atob(text.replace(/-/g, '+').replace(/_/g, '/'));
    var bytes = Uint8Array.from(binary, function (c) { return c.charCodeAt(0); });
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Same look as the cart lines of the theme: the number only, with the store's separators. */
  /* With the currency, like the other rows of the bag (ISAIA, 19-10-2026). */
  function formatMoney(cents) {
    var format = (window.theme && (window.theme.moneyWithCurrencyFormat || window.theme.moneyWithoutCurrencyFormat)) || '{{amount}}';
    var value = (cents / 100).toFixed(2).split('.');
    var whole = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, kind) {
      if (kind === 'amount_no_decimals') return whole;
      if (kind === 'amount_with_comma_separator') return value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + value[1];
      if (kind === 'amount_no_decimals_with_comma_separator') return value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return whole + '.' + value[1];
    }).replace(/<[^>]*>/g, '');
  }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  function sameSku(a, b) {
    return String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  }

  function isTargetUrl(href) {
    try {
      return config.targetHosts.indexOf(new URL(href, location.href).hostname.replace(/^www\./, '')) !== -1;
    } catch (e) {
      return false;
    }
  }

  /* What did not make it: items, and notices such as a discount code not valid here. */
  function readStored() {
    try {
      var stored = JSON.parse(localStorage.getItem(NA_KEY) || 'null');
      if (!stored || !(stored.ts >= NA_SINCE) || Date.now() - stored.ts > NA_TTL) return { items: [], notices: [] };
      return { items: stored.items || [], notices: stored.notices || [] };
    } catch (e) {
      return { items: [], notices: [] };
    }
  }

  function writeNA(items, notices) {
    notices = notices || [];
    try {
      if (items.length || notices.length) localStorage.setItem(NA_KEY, JSON.stringify({ ts: Date.now(), items: items, notices: notices }));
      else localStorage.removeItem(NA_KEY);
    } catch (e) {}
  }

  /* ---------- leaving: send the bag to the other store ---------- */

  /* options.toCart: land on the cart of the other store (from the cart page or the checkout).
     config.landing 'cart': a bag always lands on the cart; 'page': on the same page, with a notice. */
  /* The published theme leaves through this store's own redirect; a theme in preview goes straight there. */
  function viaExit(path) {
    return !!(path && window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  }

  /* An empty bag: the same page of the other store, through the redirect (the page travels as ct_r). */
  function leaveEmpty(href, back) {
    if (!viaExit(config.exitPath)) {
      location.href = href;
      return;
    }
    var params = new URLSearchParams();
    try { new URL(href, location.href).searchParams.forEach(function (value, key) { params.set(key, value); }); } catch (e) {}
    params.set('ngr-popup-redirected', '1');
    if (back) params.set('ct_r', back);
    location.href = config.exitPath + '?' + params.toString();
  }

  function go(href, options) {
    options = options || {};
    var onCart = /^\/cart\/?$/.test(location.pathname);
    var back = options.toCart || onCart || config.landing !== 'page' ? '' : location.pathname;
    var page = options.toCart || onCart ? '' : location.pathname;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          leaveEmpty(href, page);
          return;
        }
        var country = '';
        try { country = new URL(href, location.href).searchParams.get('country') || ''; } catch (e) {}
        var codes = [];
        (cart.discount_codes || []).forEach(function (entry) {
          if (entry.applicable && entry.code && codes.indexOf(entry.code) === -1) codes.push(entry.code);
        });
        var payload = {
          v: 1,
          n: Date.now(),
          from: config.sourceHost,
          c: country,
          d: codes,
          r: back,
          items: cart.items.map(function (item) {
            var properties = {};
            Object.keys(item.properties || {}).forEach(function (key) {
              if (key.charAt(0) !== '_' && item.properties[key]) properties[key] = item.properties[key];
            });
            return {
              h: item.handle,
              s: item.sku,
              q: item.quantity,
              t: item.product_title,
              o: item.product_has_only_default_variant ? [] : (item.options_with_values || []).map(function (option) { return [option.name, option.value]; }),
              i: item.image ? String(item.image).split('?')[0] : '',
              p: properties
            };
          })
        };
        var query = '?ngr-popup-redirected=1&cart_transfer=' + encode(payload);
        var url = viaExit(config.exitCartPath) ? config.exitCartPath + query : config.targetOrigin + '/cart' + query;
        if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && config.targetPreviewTheme) {
          url += '&preview_theme_id=' + config.targetPreviewTheme;
        }
        track('cart_transfer_start', { cart_transfer_from: config.sourceHost, cart_transfer_to: config.targetHosts[0], cart_transfer_items: cart.item_count, cart_transfer_country: country });
        /* The bag now lives on the other store: empty it here, so the customer does not find it twice (ISAIA, 21-10-2026).
           The analytics event gets the same moment to leave. */
        var leave = function () { location.href = url; };
        Promise.all([
          fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () {}),
          new Promise(function (resolve) { setTimeout(resolve, 150); })
        ]).then(leave, leave);
      })
      .catch(function () {
        leaveEmpty(href, page);
      });
  }

  function linkFromEvent(event) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.tagName === 'A' && node.getAttribute('href') && isTargetUrl(node.href)) return node;
    }
    return null;
  }

  function onClick(event) {
    var link = linkFromEvent(event);
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    go(link.href);
  }

  function onTouch(event) {
    /* The geo app navigates on touch on iOS: leave it to the click that follows. */
    if (linkFromEvent(event)) event.stopPropagation();
  }

  function watch(root) {
    if (root.__cartTransfer) return;
    root.__cartTransfer = true;
    root.addEventListener('click', onClick, true);
    root.addEventListener('touchstart', onTouch, { capture: true, passive: true });
    root.addEventListener('touchend', onTouch, { capture: true, passive: true });
  }

  window.addEventListener('click', onClick, true);
  (window.isaiaCartTransferRoots || []).forEach(watch);

  /* ---------- arriving: rebuild the bag ---------- */

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function searchHandles(sku) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return products.map(function (product) { return product.handle; });
      })
      .catch(function () { return []; });
  }

  /* Best variant with the same SKU: available first, then the same handle as the source. */
  function pick(products, item) {
    var best = null;
    products.forEach(function (product) {
      (product.variants || []).forEach(function (variant) {
        if (!sameSku(variant.sku, item.s)) return;
        var score = (variant.available ? 2 : 0) + (product.handle === item.h ? 1 : 0);
        if (!best || score > best.score) best = { product: product, variant: variant, score: score };
      });
    });
    return best;
  }

  function resolve(item) {
    return fetchProduct(item.h).then(function (product) {
      var products = product ? [product] : [];
      var found = pick(products, item);
      if (found && found.variant.available) return found;
      return searchHandles(item.s).then(function (handles) {
        var others = handles.filter(function (handle) { return handle !== item.h; });
        return Promise.all(others.map(fetchProduct)).then(function (more) {
          return pick(products.concat(more.filter(Boolean)), item);
        });
      });
    });
  }

  function addToCart(id, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity, properties: properties }] })
    }).then(function (response) { return response.ok; });
  }

  function unavailable(item, found) {
    return {
      title: item.t,
      options: item.o || [],
      image: item.i,
      soldOut: !!found,
      url: found ? found.product.url || '/products/' + found.product.handle : '',
      price: found ? found.variant.price : null
    };
  }

  /* The waiting screen of the page (snippets/cart-transfer-overlay.liquid, on the cart); elsewhere a plain one. */
  function showOverlay() {
    var overlay = document.querySelector('.cart-transfer-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-transfer-overlay';
      overlay.innerHTML = '<div class="cart-transfer-overlay__inner">' +
        '<p class="cart-transfer-overlay__title">' + escapeHtml(config.strings.transferringTitle || '') + '</p>' +
        '<p class="cart-transfer-overlay__text">' + escapeHtml(config.strings.transferring) + '</p></div>';
      document.body.appendChild(overlay);
    }
    overlay.classList.add('is-active');
  }

  function receive(token) {
    var payload;
    try {
      payload = decode(token);
    } catch (e) {
      payload = null;
    }
    /* The country picked in the selector of the other store, if any, sets the market here. */
    var finish = function () {
      var country = payload && /^[A-Z]{2}$/.test(payload.c || '') ? payload.c : '';
      var query = country ? '?country=' + country : '';
      /* On a theme being previewed (tests, demos) stay on it: without the id Shopify may fall back to another
         preview open in the same browser (ISAIA, 20-10-2026). The live theme needs nothing. */
      if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && Shopify.theme.id) {
        query += (query ? '&' : '?') + 'preview_theme_id=' + Shopify.theme.id;
      }
      var back = payload && typeof payload.r === 'string' && /^\/(?!\/)/.test(payload.r) && !/^\/cart\/?$/.test(payload.r) ? payload.r : '';
      if (!back) { location.replace('/cart' + query); return; }
      /* The same page may not exist here (a product sold by one store only): then the cart. */
      fetch(back, { method: 'HEAD', credentials: 'same-origin' })
        .then(function (response) { location.replace((response.ok ? back : '/cart') + query); })
        .catch(function () { location.replace('/cart' + query); });
    };
    if (!payload || !payload.items) return finish();

    try {
      if (!payload.reset && sessionStorage.getItem(DONE_KEY) === token) return finish();
    } catch (e) {}

    showOverlay();
    var missing = [];
    var added = 0;

    /* One item at a time: the cart API does not like parallel adds.
       Demo links (reset: 1) start from an empty bag, so a demo can be run again and again. */
    var chain = payload.reset
      ? fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).catch(function () {})
      : Promise.resolve();

    /* Variants already in this bag (a second transfer, a previous visit): they count as transferred,
       even when the store has no further stock to add another one. */
    var inCart = {};
    chain = chain
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (response) { return response.json(); })
      .then(function (cart) { (cart.items || []).forEach(function (line) { inCart[line.variant_id] = true; }); })
      .catch(function () {});

    payload.items.forEach(function (item) {
      chain = chain.then(function () {
        return resolve(item).then(function (found) {
          if (found && inCart[found.variant.id]) { added += 1; return; }
          if (!found || !found.variant.available) {
            missing.push(unavailable(item, found));
            return;
          }
          return addToCart(found.variant.id, item.q, item.p).then(function (ok) {
            if (ok || item.q <= 1) return ok;
            return addToCart(found.variant.id, 1, item.p);
          }).then(function (ok) {
            if (ok) added += 1;
            else missing.push(unavailable(item, found));
          });
        });
      });
    });

    var notices = [];
    var codes = (payload.d || []).filter(Boolean);
    chain
      .then(function () {
        var update = { attributes: { _cart_transfer_from: payload.from || '' } };
        if (codes.length) update.discount = codes.join(',');
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(update)
        }).then(function (response) { return response.json(); });
      })
      .then(function (cart) {
        /* A code of the other store may not exist here: say so instead of dropping it silently. */
        var applied = {};
        ((cart && cart.discount_codes) || []).forEach(function (entry) {
          if (entry.applicable) applied[String(entry.code).toUpperCase()] = true;
        });
        var keep = [];
        codes.forEach(function (code) {
          if (applied[String(code).toUpperCase()]) keep.push(code);
          else notices.push({ type: 'discount', code: code });
        });
        track('cart_transfer_complete', {
          cart_transfer_from: payload.from || '',
          cart_transfer_items: payload.items.length,
          cart_transfer_unavailable: missing.length,
          cart_transfer_discount_not_applied: notices.length
        });
        /* Shopify keeps a code that does not apply: take it off, so checkout does not show it again. */
        if (notices.length) {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: keep.join(',') })
          });
        }
      })
      .catch(function () {})
      .then(function () {
        writeNA(missing, notices);
        try {
          sessionStorage.setItem(DONE_KEY, token);
          sessionStorage.setItem(TOAST_KEY, JSON.stringify({ added: added, missing: missing.length, notices: notices.length }));
        } catch (e) {}
        /* A moment for the analytics event to leave before the page reloads. Demo links (hold: ms, at most 10 s)
           keep the waiting screen a little longer, so it can be shown (ISAIA, 20-10-2026). */
        setTimeout(finish, Math.max(300, Math.min(Number(payload.hold) || 0, 10000)));
      });
  }

  /* ---------- cart page and sidebar: items that did not make it ---------- */

  function rowHtml(item, index) {
    var title = escapeHtml(item.title);
    /* The theme sizes the picture through the link around it: keep the link even without a page to open. */
    var image = '<a' + (item.url ? ' href="' + escapeHtml(item.url) + '"' : '') + ' aria-label="' + title + '">' +
      (item.image ? '<div class="lazy-image"><img src="' + escapeHtml(item.image) + '?width=180" alt="' + title + '" width="90" loading="lazy"></div>' : '') +
      '</a>';
    var name = item.url ? '<a href="' + escapeHtml(item.url) + '">' + title + '</a>' : title;
    var options = (item.options || []).map(function (option) {
      return '<p class="cart__item__selected-options"><strong>' + escapeHtml(option[0]) + ':</strong> <span>' + escapeHtml(option[1]) + '</span></p>';
    }).join('');
    var price = '<p class="cart__price">' + (item.price != null ? escapeHtml(formatMoney(item.price)) : '') + '</p>';
    return '<div class="cart__item" data-cart-transfer-na-item="' + index + '">' +
      '<div class="cart__item__image' + (item.image ? '' : ' image--empty') + '">' + image + '</div>' +
      '<div class="cart__item__content">' +
        '<div class="cart__item__content-inner">' +
          '<h4 class="cart__item__title">' + name + '</h4>' +
          '<div class="cart__item__meta">' + options +
            '<p class="cart-transfer-na__message">' + escapeHtml(item.soldOut ? config.strings.soldOut : config.strings.notAvailable) + '</p>' +
          '</div>' +
        '</div>' +
        price +
        (item.soldOut && notifyPanel() ?
          '<button type="button" class="cart-transfer-na__notify" data-cart-transfer-notify="' + index + '">' + escapeHtml(notifyPanel().getAttribute('data-label') || '') + '</button>' : '') +
        '<div class="cart__quantity-counter cart-transfer-na__actions">' +
          '<a class="cart__item__remove" href="#" data-cart-transfer-dismiss="' + index + '">' + escapeHtml(config.strings.remove) + '</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function noticeHtml(notice, index) {
    var text = config.strings.discountNotApplied.replace('{code}', notice.code);
    return '<p class="cart-transfer-na__notice">' + escapeHtml(text) +
      ' <a href="#" data-cart-transfer-dismiss-notice="' + index + '">' + escapeHtml(config.strings.remove) + '</a></p>';
  }

  /* The notify-me panel of the cart page (sections/cart.liquid), the same one as the product page (ISAIA, 20-10-2026). */
  function notifyPanel() {
    return document.querySelector('[data-cart-transfer-notify-modal]');
  }

  function openNotify(item) {
    var modal = notifyPanel();
    if (!modal) return;
    var variant = (item.options || []).map(function (option) { return option[1]; }).join(' / ');
    var title = modal.querySelector('[data-cart-notify-title]');
    var variantText = modal.querySelector('[data-cart-notify-variant]');
    var field = modal.querySelector('[data-cart-notify-product]');
    if (title) title.textContent = item.title;
    if (variantText) { variantText.textContent = variant; variantText.hidden = !variant; }
    if (field) field.value = item.title + (variant ? ' - ' + variant : '');
    var trigger = modal.querySelector('[data-popup-open]');
    if (trigger) trigger.click();
  }

  function render() {
    var stored = readStored();
    var items = stored.items;
    var notices = stored.notices;
    var count = String(items.length) + '/' + String(notices.length);
    var page = document.querySelector('[data-cart-page]');
    if (page) page.classList.toggle('cart-transfer-only', items.length > 0 && page.classList.contains('is-empty'));
    document.querySelectorAll('.cart-transfer-na').forEach(function (block) {
      if ((!items.length && !notices.length) || block.getAttribute('data-count') !== count) block.remove();
    });
    if (!items.length && !notices.length) return;
    var html = notices.map(noticeHtml).join('') + items.map(rowHtml).join('');
    var place = function (anchor, where, className) {
      var block = document.createElement('div');
      block.className = className;
      block.setAttribute('data-count', count);
      block.innerHTML = html;
      anchor.insertAdjacentElement(where, block);
    };
    /* Inside the theme's own list, so the rows take its styles; redrawn when the theme redraws it.
       With an empty bag the theme shows its empty state instead (".is-empty"): the rows go there. */
    document.querySelectorAll('[data-items-holder]').forEach(function (holder) {
      var block = holder.querySelector(':scope > .cart-transfer-na');
      if (holder.closest('.is-empty') && !holder.closest('[data-cart-page]')) {
        if (block) block.remove();
      } else if (!block) {
        place(holder, 'beforeend', 'cart-transfer-na');
      }
    });
    document.querySelectorAll('[data-cart-empty]').forEach(function (empty) {
      var inner = empty.querySelector('.drawer__empty__inner') || empty;
      var block = inner.querySelector(':scope > .cart-transfer-na');
      if (!empty.closest('.is-empty') || empty.closest('[data-cart-page]')) {
        if (block) block.remove();
      } else if (!block) {
        var heading = inner.querySelector(':scope > .cart__title, :scope > .drawer__empty__message');
        if (heading) place(heading, 'afterend', 'cart-transfer-na cart__items');
        else place(inner, 'afterbegin', 'cart-transfer-na cart__items');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var notify = event.target.closest && event.target.closest('[data-cart-transfer-notify]');
    if (notify) {
      var row = readStored().items[Number(notify.getAttribute('data-cart-transfer-notify'))];
      if (row) openNotify(row);
      return;
    }
    var link = event.target.closest && event.target.closest('[data-cart-transfer-dismiss], [data-cart-transfer-dismiss-notice]');
    if (!link) return;
    event.preventDefault();
    var stored = readStored();
    if (link.hasAttribute('data-cart-transfer-dismiss')) stored.items.splice(Number(link.getAttribute('data-cart-transfer-dismiss')), 1);
    else stored.notices.splice(Number(link.getAttribute('data-cart-transfer-dismiss-notice')), 1);
    writeNA(stored.items, stored.notices);
    render();
  });

  /* After a transfer that did not end on the cart: a short notice with the outcome. */
  function toast() {
    var data;
    try { data = JSON.parse(sessionStorage.getItem(TOAST_KEY) || 'null'); sessionStorage.removeItem(TOAST_KEY); } catch (e) { data = null; }
    /* Off in Theme settings > Cart transfer ("Show the notice"): nothing is shown (ISAIA, 22-10-2026). */
    if (!data || !config.toastEnabled || /^\/cart\/?$/.test(location.pathname)) return;
    var t = config.strings;
    var parts = [];
    if (data.added) parts.push(data.added + ' ' + (data.added === 1 ? t.toastItem : t.toastItems) + ' ' + t.toastAdded);
    if (data.missing) parts.push(data.missing + ' ' + t.toastNotAvailable);
    var box = document.createElement('div');
    box.className = 'cart-transfer-toast';
    box.setAttribute('role', 'status');
    box.innerHTML = '<span>' + escapeHtml(t.toastTitle + (parts.length ? ': ' + parts.join(', ') : '') + '.') + '</span>' +
      ' <a href="/cart">' + escapeHtml(t.toastViewBag) + '</a>' +
      '<button type="button" aria-label="Close">&times;</button>';
    document.body.appendChild(box);
    var close = function () { box.classList.remove('is-visible'); setTimeout(function () { box.remove(); }, 400); };
    box.querySelector('button').addEventListener('click', close);
    setTimeout(function () { box.classList.add('is-visible'); }, 50);
    setTimeout(close, config.toastDuration || 10000);
  }

  /* The checkout of the other store cannot ship there: its "click here" points to /cart?ship_to=XX. */
  function shipToTarget(country) {
    if (!/^[A-Z]{2}$/.test(country)) return false;
    return config.targetCountries === '*' ? config.ownCountries.indexOf(country) === -1 : config.targetCountries.indexOf(country) !== -1;
  }

  function start() {
    var params = new URLSearchParams(location.search);
    var token = params.get('cart_transfer');
    if (token) {
      receive(token);
      return;
    }
    /* Came over with an empty bag: back to the page the customer was on, if it exists here. */
    var page = params.get('ct_r') || '';
    if (/^\/(?!\/)/.test(page) && !/^\/cart\/?$/.test(page) && page !== location.pathname) {
      var country = /^[A-Z]{2}$/.test(params.get('country') || '') ? '?country=' + params.get('country') : '';
      fetch(page, { method: 'HEAD', credentials: 'same-origin' })
        .then(function (response) { location.replace(response.ok ? page + country : location.pathname + country); })
        .catch(function () { document.documentElement.classList.remove('cart-transfer-busy'); });
      return;
    }
    var shipTo = (params.get('ship_to') || '').toUpperCase();
    /* The banner of the isaia.us checkout, "other countries": no country given, it is chosen at the isaia.it checkout (ISAIA, 22-10-2026). */
    if (shipTo === 'INTL' && config.targetCountries === '*') {
      document.documentElement.classList.add('cart-transfer-busy');
      showOverlay();
      go(config.targetOrigin + '/', { toCart: true });
      return;
    }
    if (shipToTarget(shipTo)) {
      document.documentElement.classList.add('cart-transfer-busy');
      showOverlay();
      go(config.targetOrigin + '/' + (config.targetCountries === '*' ? '?country=' + shipTo : ''), { toCart: true });
      return;
    }
    document.documentElement.classList.remove('cart-transfer-busy');
    toast();
    render();
    /* The theme redraws the cart after every change: put the block back when it does. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        var stored = readStored();
        if (stored.items.length || stored.notices.length) render();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  window.isaiaCartTransfer = { go: go, watch: watch, render: render };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
